module.exports = __webpack_public_path__ + "img/6_9.edf1e948.png";